$(document).ready(function() {
    if ($(window).width() < 992 ) {
        $('.menu-responsive-button').click(function() {
            $('.menu-ul').toggleClass('hidden-sm');
        });
    }

    function trackEvent(category, action, label, value) {
        dataLayer.push({
            event: 'eventTracking',
            eventCategory: category,
            eventAction: action,
            eventLabel: label,
            eventValue: value
        });
    }

    function showMenu() {
        $('body')
            .addClass('menu-open')
            .find('.menu-main-wrapper')
            .show();

        setTimeout(function() {
            $('.menu-main-overlay').addClass('js-fade-in');
            $('.menu-main-box').addClass('menu-main-box-show');
        }, 50);

        // Nastaveni vysky menu
        $('.menu-main-overlay, .menu-main-box').css({'min-height': $('.menu-main-box-list').height() + 92})
    }

    function hideMenu() {
        $('.menu-main-overlay').removeClass('js-fade-in');
        $('.menu-main-box').removeClass('menu-main-box-show');

        setTimeout(function() {
            $('.menu-main-wrapper').hide();
            $('body').removeClass('menu-open');
        }, 400);
    }

    $("#reservio-plus-more").click(function(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $("#reservio-plus-content").offset().top
        }, 1000);
    });

    // Posunuti bublinky v intru
    $('.page-intro-view').addClass('page-intro-view-show');

    // Menu otevreni
    $('.menu-main-btn').click(function(){
        showMenu();
    });

    // Menu zavreni
    $('.menu-main-close').click(function(){
        hideMenu();
    });


    // Skryti menu po kliknuti mimo nej
    $('html').click(function() {
        hideMenu();
    });
    $('.menu-main-btn, .menu-main-box').click(function(event){
        event.stopPropagation();
    });

    // Preklikavani polozek v accordionu
    $('.box-accordion-title').click(function() {
        $(this).closest('.box-accordion').find('.box-accordion-inner').slideUp(300);
        if( !$(this).next('.box-accordion-inner').is(':visible')){
            $(this).next('.box-accordion-inner').slideDown(300);
        }

        setTimeout(function() {
            $(document).focus();
        }, 300);
    });

    // Stejne vysoke boxy v pricingu
    var safety = $('.box-safety');
    var payment = $('.box-payment');
    var height = Math.max(safety.height(), payment.height());
    safety.height(height);
    payment.height(height);

    var getStarted = $('.box-get-started');
    var plus = $('.box-plus');
    var height = Math.max(getStarted.height(), plus.height());
    getStarted.height(height);
    plus.height(height);

    function faqHash(){
        if( window.location.hash != '') {

             $(window.location.hash).click(); 
        }
    }

    // Preklikavani polozek ve FAQ
    $('.box-faq-item-title').click(function() {
        $(this).closest('.box-faq').find('.box-faq-item-inner').slideUp(300);
        if( !$(this).next('.box-faq-item-inner').is(':visible')){
            $(this).next('.box-faq-item-inner').slideDown(300);
        }
        if($(this).closest('.box-faq-item-last').length){
            $('html, body').animate({
                scrollTop: $(this).offset().top
            }, 1000);
        }

        trackEvent('help', 'titleClicked', $(this).attr('id'));

        setTimeout(function() {
            $(document).focus();
        }, 300);
    });

    // Posun na smsky
    $('.show-sms-faq').click(function(e) {
        var $title = $('#sms-faq .box-faq-item-title');

        // Nechceme standardni chovani kotvy
        e.preventDefault();
        // Zobrazíme SMS sekci
        $('.box-faq-item-inner').slideUp(300);
        $title.next('.box-faq-item-inner').slideDown(300);
        // A animaci odscrollujeme na nej
        $('html, body').animate({
            scrollTop: $title.offset().top
        }, 1000);
    });


    $('.legend .item-body').click(function(){
        $('.form-pricing').submit();
    });

    // Preklikavani polozek v pricing listu
    $('.crossroad-premium-plans .info').click(function(e) {
        if($(this).closest('.plan-disabled').length) {
            e.preventDefault();
            return;
        }
        $('.crossroad-premium-plans .info').removeClass('open');
        $(this).addClass('open');
        $(this).find('input').prop('checked', true);

        trackEvent('pricingTable', 'planClicked', $(this).attr('id'));
    });

    // zmena hodnot v selectboxu pricingu
    $('.selectbox-pricing-sms').change(function(){
        $('.box-faq-table').hide();
        $('.sms-pricing-'+$(this).val()).show();
    });
    $('.selectbox-pricing-sms').change();


    // Zavreni cookies
    $('.box-cookies-close').click(function() {
        Cookies.set('cookies_box', 'closed');
        $(this).closest('.box-cookies').addClass('box-cookies-hidden');
    });

    if($('#modalSign').find('.form-group-error').length > 0) {
        $('.modal-signup-button').first().click();
    }

    if($('#modal-reservioPlus').find('.form-group-error').length > 0) {
        $('#modal-reservioPlus-open').click();
    }

    $('.language-change').click(function () {
        Cookies.set('lang', $(this).data('lang'));
    });

    function loadImages() {
        $('.defered-image').each(function() {
            loadImage($(this));
        });
    }

    function loadImage($image) {
        $image.attr('src', $image.data('src'));
    }

    var $header = $('.header'),
        lastScrollTop = $(window).scrollTop();
    function loadHeader(){
        var scroll = $(window).scrollTop();

        // Downscroll
        if(scroll == 0 || scroll > lastScrollTop) {
            if($(window).width() >= 960) {
                if(scroll >= 120) {
                    if(!$('body').hasClass('page-homepage')) {
                        $('body').addClass('body-main-padding');
                    }
                    $header.addClass('header-none');
                }
                else {
                    $header.removeClass('header-none');
                    $('body').removeClass('body-main-padding');
                }


                if(scroll >= 184) {
                    $header.addClass('header-fix');
                    $header.find('.header-login').addClass('header-login-hide');
                    $header.find('.header-create').addClass('header-create-show');
                }
                else {
                    $header.removeClass('header-fix');
                    $header.find('.header-login').removeClass('header-login-hide');
                    $header.find('.header-create').removeClass('header-create-show');
                }
            }
            else {
                $('body').removeClass('body-main-padding');
                $header.removeClass('header-none');
                $header.removeClass('header-fix');
                $header.find('.header-login').removeClass('header-login-hide');
                $header.find('.header-create').removeClass('header-create-show');
            }
        }
        else {
            if(scroll < 184) {
                $('body').removeClass('body-main-padding');
                $header.removeClass('header-none');
                $header.removeClass('header-fix');
                $header.find('.header-login').removeClass('header-login-hide');
                $header.find('.header-create').removeClass('header-create-show');
            }
        }

        lastScrollTop = scroll;

        if(!isScrolled) {
            loadImages();
        }
    }

    faqHash();

    $('.btn-renew').click(function (e) {
        e.preventDefault();
    });

    $('.list--subscription .list__inner').click(function (e) {
        if (typeof window.google_tag_manager !== 'undefined') {
            e.preventDefault();

            var targetUrl = this.href;

            dataLayer.push({
                event: 'eec.addToCart',
                ecommerce: {
                    currencyCode: $(this).data('product-currency'),
                    add: {                                // 'add' actionFieldObject measures.
                        products: [{                        //  adding a product to a shopping cart.
                            name: $(this).data('product-name'),
                            id: $(this).data('product-sku'),
                            price: $(this).data('product-price'),
                            category: 'Premium plans',
                            variant: $(this).data('product-variant'),
                            quantity: 1
                        }]
                    }
                },
                eventCallback: function () {
                    window.location = targetUrl;
                }
            });
        }
    });

    $('.list--subscription .radio__input').change(function () {
        $(this).parents('.list').find('.list__inner').removeClass('list__inner--active');
        $(this).parents('.list__inner').addClass('list__inner--active');
    });

    function dataLayerPush(data, callback) {
        if (!window.google_tag_manager) {
            // If someone has adblock installed eventCallback won't be fired at all.
            // So we need it to call it right away. No need to push event to dataLayer at all.
            callback(null);
            return;
        }

        var dataToPush = Object.assign({}, data);
        if (callback) {
            dataToPush.eventCallback = callback;
            dataToPush.eventTimeout = 2000;
        }
        dataLayer.push(dataToPush);
    }

    $('#menu-app-link').one('click', function (e) {
        var link = $(this);
        e.preventDefault();
        dataLayerPush({
            event: 'login',
            type: 'clickToName'
        }, function () {
            link[0].click();
        });
    });

    $('form[name="login_form"]').one('submit', function (e) {
        var form = $(this);
        e.preventDefault();
        dataLayerPush({
            event: 'login',
            type: 'signIn'
        }, function () {
            form.submit();
        });
    });

    $(document).one('submit', '#frm-signup', function (e) {
        var $form = $(this),
            $submitButton = $form.find('button[type="submit"]');

        e.preventDefault();

        dataLayerPush({
            event: 'business_signup_form.submitted',
            signup_method: 'email_password'
        });

        // DEPRECATED
        dataLayerPush({
            event: 'sign_up',
        });

        if (!$submitButton.prop('disabled')) {
            $submitButton.text($submitButton.data('saving'));

            var text = $submitButton.text(),
                ticks = '.';

            $submitButton.text(text+ticks);

            setInterval(function() {
                ticks = ticks.length >= 3 ? '' : ticks+'.';
                $submitButton.text(text+ticks);
            }, 600);

            grecaptcha.ready(function() {
                grecaptcha
                    .execute('6LfV0cwZAAAAAOu58iY1xTeMxABoRi9rNkHYmyRC', { action: 'signup_submit' })
                    .then(function(token) {
                        $('<input />').attr('type', 'hidden')
                            .attr('name', 'g-recaptcha-response')
                            .attr('value', token)
                            .appendTo($form);
                        $form.submit();
                    });
            });
        }
    });



    $('.open-chat').click(function () {
        if (window.Intercom) {
            window.Intercom('show');
        }
    });

    $('.open-cookie-settings').click(function (e) {
        e.preventDefault();
        if (typeof window.revisitCkyConsent === 'function') {
            window.revisitCkyConsent();
        }
    });

    var isScrolled = $(window).scrollTop() != 0;
    //Scrollovani hlavicky
    $(window).on('resize scroll', loadHeader);

    if(isScrolled) {
        loadImages();
        loadHeader();
    }
    else {
        setTimeout(function() {
            loadImages();
        }, 3000);
    }

    function getPlanCode(button) {
        if ($(button).closest('#plan-pro').length > 0) {
            return 'pro';
        } else if ($(button).closest('#plan-standard').length > 0) {
            return 'standard';
        } else if ($(button).closest('#plan-starter').length > 0) {
            return 'starter';
        } else if ($(button).closest('#plan-free').length > 0) {
            return 'free';
        }
        return null;
    }
});
